import React from 'react'
import Fragment from '../common/fragment'


function FragmentAZ(props) {
  return (
    <Fragment pos="z" {...props}>
      <p>
En la gráfica, el horizonte está a la derecha y las montañas se desplazan desde la
izquierda para crear una sensación de movimiento. En la cúspide los cuerpos vivos,
en el abismo los cadáveres y los zombis. ¿Por qué la muerte se localiza cerca de la
Tierra y la vida en el Cielo? Veremos a dioses que no existen dispersar sus sombras
sobre estas coordenadas. “El petróleo se resiste a la estructura en cinco actos”
(Brecht).
      </p>
    </Fragment>
  )
}


export default FragmentAZ
